import { RouteRecordRaw } from 'vue-router';

export default (): Array<RouteRecordRaw> => {
    return [
        {
            path: '/cards',
            name: 'cards',
            component: () => import("./views/cards.vue"),
            meta: {
                hasBar: true
            }
        }
    ];
};